module.exports = (function anonymous(locals, filters, escape, rethrow
/**/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="sponsor-front">\n<div class="sponsor-image">\n  ');3; if (url) { ; buf.push('\n  <a href="', escape((4,  url )), '"><img src="', escape((4,  frontLogo )), '" alt="Logo of ', escape((4,  name )), '"></img></a>\n  ');5; } else { ; buf.push('\n  <img src="', escape((6,  frontLogo )), '"></img>\n  ');7; } ; buf.push('\n</div>\n</div>\n'); })();
} 
return buf.join('');
})